import React from "react";
import { colors } from "../../constants/colors";
import teamHands from "../../images/teamHands.png";
export const TeamBanner = () => {
  return (
    <section
      // data-aos="zoom-in-up"
      className="team-banner container-fluid px-0"
      id="team-banner"
      style={{ backgroundColor: colors.gencLightBlue }}
    >
      <div className="row no-gutters">
        <div
          className="team-banner-details d-flex justify-content-center align-items-center col-xs-12 text-center col-sm-12 col-md-5 text-md-left"
          data-aos="fade-left"
          data-aos-delay="250"
        >
          <div className="p-5">
            <h1 style={{ color: colors.gencBlue }}>Our Team</h1>
            <p style={{ color: colors.gencBlack }}>
              We are the team of technologists who invented a new protocol for
              centralized servers and data centers to store applications’ data
              in a way that is immune to data breaches. If HyperText Transfer
              Protocol prescribes a procedure for requests and responses, which
              makes the internet works, Angelo Network Data-Store Protocol
              prescribes that a data file should reside in more than one
              centralized server, which makes hacking centralized data servers a
              meaningless endeavor.
            </p>
          </div>
        </div>
        <div
          className="col-xs-12 col-sm-12 col-md-7"
          data-aos="fade-right"
          data-aos-delay="250"
        >
          <img src={teamHands} alt="Team Hands" />
        </div>
      </div>
    </section>
  );
};
